<template>
  <div data-testid="BaseModalControls" class="d-flex justify-content-between">
    <b-button
      v-if="onCancel"
      :variant="cancelVariant"
      class="mx-1"
      @click="onCancel"
    >
      {{ cancelLabel }}
    </b-button>
    <b-button :variant="okVariant" class="mx-1" @click="handleOk">
      {{ okLabel }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'BaseModalControls',
  props: {
    onOk: {
      type: Function,
      default: () => {}
    },
    onCancel: {
      type: Function,
      default: null
    },
    okLabel: {
      type: String,
      default: 'OK'
    },
    cancelLabel: {
      type: String,
      default: 'Cancel'
    },
    okVariant: {
      type: String,
      default: 'primary'
    },
    cancelVariant: {
      type: String,
      default: 'info'
    }
  },
  methods: {
    handleOk() {
      this.onOk(this.onCancel)
    }
  }
}
</script>
